import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs';
import { Loginservices } from 'src/app/login/login.services';
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-usersubmenu',
  templateUrl: './usersubmenu.component.html',
  styleUrls: ['./usersubmenu.component.css']
})
export class UsersubmenuComponent {
  usermenuVisible = false;
  downloadbackupmessage = "This function will generate the complete Backup of the Common Masters." +
    "An Excel file with different tabs containing various Masters will be generated and placed in the Download directory.";
  @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.dropdownWrapper?.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.usermenuVisible = false;
    }
  }
  currentUrl = ''
  usermenu = [];
  loginusername = '';
  userdata: any;
  orgType = "";
  requireVertical = "";
  verticalLabel = "";
  hasLimitedAccess = "";
  orgId = "";
  backupDownloadFlag = "Y";
  requireHub = "";
  requireRegion = "";
  requireSubVertical = "";
  subVerticalLabel = "";
  requireCity = "";
  requireLocationType = "";
  locationTypeLabel = "";
  requireSubDepartment = "";
  subDepartmentLabel = "";
  userRole: Number;
  backupModal = false;
  backupApi = 'common/commonmasterbackup/commonmastersDataExcel';
  tssprtlimitedaccess = "N";
  compissupportadmin: string;
  orgStatsUserList: string[] = [
    "3", "7", "10", "480", "9610",
    "13", "14", "8893", "8922", "9615", "13340","11685"
  ];
  userId: string;



  constructor(public utilityservice: Utilityservice, private router: Router, private dialogService: DialogService,
    private loginservice: Loginservices
  ) {
    this.userdata = this.utilityservice.getLoggeduser();
    this.currentUrl = window.location.href;
    const fullName = `${this.userdata?.firstname ?? ''} ${this.userdata?.lastname ?? ''}`.trim();
    this.loginusername = fullName.length > 16 ? fullName.substring(0, 16) + '...' : fullName;

    //this.userRole = this.userdata?.userRole;
    // this.orgType = this.userdata?.orgtype;
    // this.requireVertical = this.userdata?.requirevertlabel;
    // this.hasLimitedAccess = this.userdata?.haslimitedaccess;
    // this.verticalLabel = this.userdata?.vertlabelname;
    // this.orgId = this.userdata?.orgif;
    //this.backupDownloadFlag = this.userdata?.backupdownloadflag;
    this.utilityservice.configParams$.subscribe((data: any) => {
      const responseArray = data;
      if (responseArray) {
        const config = responseArray;
        this.userRole = config.genroleid;
        this.verticalLabel = config.vertlabelname;
        this.subVerticalLabel = config.subvertlabelname;
        this.requireVertical = config.requirevertlabel;
        this.requireSubDepartment = config.requiresubdeptlabel;
        this.requireSubVertical = config.requiresubvertlabel;
        this.subDepartmentLabel = config.subdeptlabelname;
        this.requireHub = config.ishub;
        this.requireCity = config.iscity;
        this.requireLocationType = config.islocationtype;
        this.requireRegion = config.isregion;
        this.locationTypeLabel = config.locationtypelabel;
        this.orgId = config.orgid;
        this.hasLimitedAccess = config.haslimitedaccess;
        this.orgType = config.orgtype;
        this.backupDownloadFlag = config.backupdownloadflag;
        this.compissupportadmin = config.issupportadmin;
        this.userId = config.userid;
        if(this.compissupportadmin == "Y"){
          this.backupDownloadFlag = "Y";
        } 
        if (this.hasLimitedAccess == "Y" && this.compissupportadmin == "Y") {
          this.tssprtlimitedaccess = "Y";
          this.backupDownloadFlag = "Y";
        }


        //this.loginusername = config.fname + ' ' + config.lname;
        //this.loginusername = config.username;
      }
      this.getusermenulist();
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.usermenuVisible = false;
      });
  }


  toggleUserMenu() {
    this.usermenuVisible = !this.usermenuVisible;
  }
  getusermenulist() {
    this.usermenu = [
      {
        masterlabel: 'Common Configuration',
        submenu: this.getcommonconfiglist()
      },
      {
        masterlabel: 'Common Master',
        submenu: this.getsubmenulist()
      },
      {
        masterlabel: 'Common Reports',
        submenu: this.getcommonreports()
      }
    ]
    if (this.userRole == 0) {
      const superAdminMenu = this.getsuperadminaction();
      this.usermenu = this.usermenu.concat(superAdminMenu);
    }
  }


  returnurl(url) {
    const formattedUrl = url.toLowerCase().replace(/\s+/g, '');
    const generatedUrl = `${location.origin}/${formattedUrl}/#/${formattedUrl}`;
    return generatedUrl;
  }
  handleClick(item: any): void {
    if (item.click) {
      item.click();
    } else if (item.link) {
      window.location.href = item.link;
    }
  }

  getHref(item: any): string | null {
    return item.link || 'javascript:void(0)';
  }
  getsubmenulist() {
    let list = [];

    // user role 1
    if (this.userRole == 1) {
      list = [
        // {
        //   label: 'Set Up -Pending',
        //   //link: window.location.origin + '/common/#/common/organisation',
        //   icon: 'fa fa-wrench',
        //   class: 'menu-item',
        // },
        {
          label: 'Organisation',
          link: window.location.origin + '/common/#/common/organisation',
          icon: 'fa fa-wrench',
          class: 'menu-item',
        },
        {
          label: 'Financial Year',
          link: window.location.origin + '/common/#/common/financial-year',
          icon: 'fa fa-calendar',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'Department',
          link: window.location.origin + '/common/#/common/department',
          icon: 'fa fa-building',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Location',
          link: window.location.origin + '/common/#/common/location',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'Entity',
          link: window.location.origin + '/common/#/common/entity',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'Signatory Details',
          link: window.location.origin + '/common/#/common/signatory-details',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'User Master(Unlicensed)',
          link: window.location.origin + '/common/#/common/unlicensed-user-master',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'User',
          link: window.location.origin + '/common/#/common/user',
          icon: 'fa fa-user',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'Currency',
          link: window.location.origin + '/common/#/common/currency',
          icon: 'fa fa-money-bill',
          isrighttodisplay: true,
          class: 'menu-item',
        }
      ]
      if (this.requireCity == "Y") {
        list.push(
          {
            label: 'City',
            link: window.location.origin + '/common/#/common/city',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
      }
      if (this.requireHub == "Y") {
        list.push(
          {
            label: 'Hub',
            link: window.location.origin + '/common/#/common/hub',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item',
          }
        )
      }
      if (this.requireLocationType == "Y" && this.orgType != 'P') {
        list.push(
          {
            label: this.locationTypeLabel,
            link: window.location.origin + '/common/#/common/location-type',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item',
          }
        )
      }
      if (this.requireRegion == "Y") {
        list.push(
          {
            label: 'Region',
            link: window.location.origin + '/common/#/common/region',
            icon: 'fa fa-globe',
            class: 'menu-item',
            isrighttodisplay: true
          }
        )
      }
      if (this.orgType == "P") {
        list.push(
          {
            label: 'Client Group',
            link: window.location.origin + '/common/#/common/client-group',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item'
          })
      }
      if (this.requireSubDepartment == "Y") {
        list.push(
          {
            label: this.subDepartmentLabel,
            link: window.location.origin + '/common/#/common/sub-department',
            icon: 'fa fa-building',
            isrighttodisplay: true,
            class: 'menu-item',
          }
        )
      }
      if (this.requireVertical == "Y") {
        list.push(
          {
            label: this.verticalLabel,
            link: window.location.origin + '/common/#/common/vertical',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item',
          }
        )
      }
      if (this.requireSubVertical == "Y") {
        list.push(
          {
            label: this.subVerticalLabel,
            link: window.location.origin + '/common/#/common/sub-vertical',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
      };
      if (this.orgId == "1") {
        list.push(
          {
            label: "Help Masters",
            link: window.location.origin + '/common/#/common/help-masters',
            icon: 'fa fa-globe',
            isrighttodisplay: true,
            class: 'menu-item',
          }
        )
      }
      list.sort((a, b) => a.label.localeCompare(b.label));
    };

    // end of user role  1
    // user role 2 or 3 
    // end of user role 2 or 3
    // super admin
    if (this.userRole == 0) {
      list = [
        {
          label: 'User',
          link: window.location.origin + '/common/#/common/user',
          icon: 'fa fa-user',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Broadcast Emails',
          link: window.location.origin + '/common/#/common/broadcast-emails',
          icon: 'fa fa-user',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        // {
        //   label: 'E-Signature',
        //   link: window.location.origin + '/common/#/common/e-signature', 
        //   icon: 'fa fa-vine',
        //   isrighttodisplay: true,
        //   class: 'menu-item'
        // },
        {
          label: 'Version Update Report',
          link: window.location.origin + '/common/#/common/version-update-report',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item'
        },
        {
          label: 'State',
          link: window.location.origin + '/common/#/common/state',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        }, {
          label: 'Country',
          link: window.location.origin + '/common/#/common/country',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        }, {
          label: 'Entity Type',
          link: window.location.origin + '/common/#/common/entity-type',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        }, {
          label: 'Organisation',
          link: window.location.origin + '/common/#/common/organisation',
          icon: 'fa fa-wrench',
          class: 'menu-item',
        }, {
          label: 'Location',
          link: window.location.origin + '/common/#/common/location',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        },
        {
          label: 'Entity',
          link: window.location.origin + '/common/#/common/entity',
          icon: 'fa fa-globe',
          isrighttodisplay: true,
          class: 'menu-item',
        }
      ]
      list.sort((a, b) => a.label.localeCompare(b.label));
    }
    // end of super admin
    list.push(
      {
        label: 'Help',
        link: window.location.origin + '/common/#/common/help',
        icon: 'fa fa-question',
        class: 'menu-item',
        isrighttodisplay: true
      },
      {
        label: 'Logout',
        click: () => {
          this.utilityservice.logoutAndRedirect();
        },
        // link:window.location.origin+'/common/#/login',     
        icon: 'fa fa-power-off',
        isrighttodisplay: true,
        class: 'menu-item-colorred'
      },
    )
    return list
  }
  doLogout_pre() {

    let subdomain = window.location.hostname.split('.')[0]
    const host = window.location.hostname; // rasi.complinity.in
    const parts = host.split('.');
    const baseDomain = parts.slice(-2).join('.');
    this.utilityservice.logout().subscribe(() => {
      if (baseDomain == "complinity.in" || baseDomain == "complinity.com" || baseDomain == "complinity.info") {
        const paylaod = { "subdomain": window.location.hostname.split('.')[0] }
        this.utilityservice.checkorginitial(paylaod).subscribe(res => {
          if (res && res.length > 0) {
            if (subdomain == "rasi") {
              localStorage.clear();
              window.location.href = "https://portal.rasiseeds.com/adfs/ls/?wa=wsignout1.0";
            }
            if (subdomain == "maxhealthcare") {
              localStorage.clear();
              window.location.href = "https://maxcrm.maxhealthcare.com/adfs/ls/?wa=wsignout1.0";

            }
          } else {
            localStorage.clear();
            window.location.href = location.origin + "/common/#/login"
            location.reload()

          }

        }, error => {
          localStorage.clear();
          window.location.href = location.origin + "/common/#/login"
          location.reload()

        })
      }
    });
  }
  getcommonconfiglist() {
    let list = [];
    // user type 1
    if (this.userRole == 1 && this.tssprtlimitedaccess == 'N') {
      list = [{
        label: 'My Credentials',
        link: window.location.origin + '/common/#/common/my-credentials',
        icon: 'fa fa-wrench',
        class: 'menu-item',
      },
      {
        label: 'My Configuration',
        link: window.location.origin + '/common/#/common/my-configuration',
        icon: 'fa fa-gear',
        class: 'menu-item',
      },
      {
        label: 'User Additional Mapping',
        link: window.location.origin + '/common/#/common/user-access-mapping',
        icon: 'fa fa-address-book',
        isrighttodisplay: true,
        class: 'menu-item'
      },
      {
        label: 'Application Configuration',
        link: window.location.origin + '/common/#/common/application-configuration',
        icon: 'fa fa-gears',
        class: 'menu-item'
      },
      {
        label: 'Invalid File Extensions',
        link: window.location.origin + '/common/#/common/invalid-file-extensions',
        icon: 'fa fa-gears',
        class: 'menu-item'
      }

        //  {
        //    label:'Organisation',
        //    link:window.location.origin+'/common/#/common/organisation',
        //    icon:'fa fa-wrench',
        //    class:'menu-item',
        //  },
      ]
    }
    // end of user type 1
    // if user type 1 or 0 push app config
    if (this.userRole == 0) {
      list.push(
        {
          label: 'Application Configuration',
          link: window.location.origin + '/common/#/common/application-configuration',
          icon: 'fa fa-gears',
          class: 'menu-item'
        }
      )
    }

    if (this.userRole == 3 || this.userRole == 2) {
      list.push(
        {
          label: 'My Configuration',
          link: window.location.origin + '/common/#/common/my-configuration',
          icon: 'fa fa-gear',
          class: 'menu-item',
        },
        {
          label: 'My Credentials',
          link: window.location.origin + '/common/#/common/my-credentials',
          icon: 'fa fa-wrench',
          class: 'menu-item',
        },
        // {
        //   label: 'E-Signature',
        //   link: window.location.origin + '/common/#/common/e-signature',
        //   icon: 'fa fa-vine',
        //   isrighttodisplay: true,
        //   class: 'menu-item'
        // }
        // {
        //   label: 'Common Dashboard',
        //   link: window.location.origin + '/common/#/common/common-dashboard',
        //   icon: 'fa fa-file-pdf-o',
        //   class: 'menu-item',
        // }
      )
    }

    list.sort((a, b) => a.label.localeCompare(b.label));
    return list
  }
  getsuperadminaction() {
    return [
      {
        masterlabel: 'Actions',
        submenu: [
          {
            label: 'Remove Organisation',
            link: window.location.origin + '/common/#/common/remove-organisation',
            icon: 'fa fa-file-pdf-o',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        ]
      }
    ];
  }

  getcommonreports() {
    let list = []
    if (this.userRole == 1 && this.tssprtlimitedaccess == 'Y') {
      if (this.backupDownloadFlag == 'Y') {
        list.push(
          {
            label: 'Common Master Backup',
            // link:window.location.origin+'/common/#/common/common-master-backup',
            click: () => this.backupModal = true,
            icon: 'fa fa-file-pdf-o',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
      }
    }
    if (this.userRole == 2) {
      list.push(
        {
          label: 'Common Dashboard',
          link: window.location.origin + '/common/#/common/common-dashboard',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item',
        },
        {
          label: 'Version Update Report',
          link: window.location.origin + '/common/#/common/version-update-report',
          //link: 'common/version-update-report',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item'
        }
      )
    }
    if (this.userRole == 3) {
      list.push(
        {
          label: 'Version Update Report',
          link: window.location.origin + '/common/#/common/version-update-report',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item'
        }
      )
    }
    if (this.userRole == 1 && this.tssprtlimitedaccess == 'N') {
      list = [
        // {
        //   label: 'SM Submission Summary',
        //   link: window.location.origin + '/common/#/common/submission-summary',
        //   icon: 'fa fa-file-pdf-o',
        //   isrighttodisplay: true,
        //   class: 'menu-item'
        // },
        {
          label: 'User Log Report',
          link: window.location.origin + '/common/#/common/user-log-report',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'E-Signature',
          link: window.location.origin + '/common/#/common/e-signature',
          icon: 'fa fa-vine',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Common Dashboard',
          link: window.location.origin + '/common/#/common/common-dashboard',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item',
        },
        {
          label: 'Common Master Audit Log',
          //link:'common/audit-log',
          link: window.location.origin + '/common/#/common/audit-log',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },

        {
          label: 'Version Update Report',
          link: window.location.origin + '/common/#/common/version-update-report',
          icon: 'fa fa-file-pdf-o',
          class: 'menu-item',
        }
      ]
      // if (this.orgType != 'P') {
      //   list.push(
      //     {
      //       label: 'Data Change Log Report',
      //       link: window.location.origin + '/common/#/common/data-change-log-report',
      //       icon: 'fa fa-file-pdf-o',
      //       isrighttodisplay: true,
      //       class: 'menu-item'
      //     }
      //   )
      // }

      if (this.backupDownloadFlag == 'Y') {
        list.push(
          {
            label: 'Common Master Backup',
            // link:window.location.origin+'/common/#/common/common-master-backup',
            click: () => this.backupModal = true,
            icon: 'fa fa-file-pdf',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
      }

      if (this.orgId == '1' || this.orgId == '3458')
        list.push(
          {
            label: 'Client Usage Report',
            link: window.location.origin + '/common/#/common/client-usage-report',
            icon: 'fa fa-file-pdf-o',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
      if (this.orgStatsUserList.includes(this.userId)) {
        list.push(
          {
            label: 'Organisation Statistics',
            link: window.location.origin + '/common/#/common/organisation-statistics',
            icon: 'fa fa-file-pdf-o',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        );
      }
    }

    // super admin
    if (this.userRole == 0) {
      list = [
        {
          label: 'Client Usage Report',
          link: window.location.origin + '/common/#/common/client-usage-report',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Change Management Errors',
          link: window.location.origin + '/common/#/common/change-management-error',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        // {
        //   label: 'Data Changes Log Report',
        //   link: window.location.origin + '/common/#/common/client-usage-report', 
        //   icon: 'fa fa-file-pdf-o',
        //   isrighttodisplay: true,
        //   class: 'menu-item'
        // },
        {
          label: 'Login Page Messages',
          link: window.location.origin + '/common/#/common/login-page-messages',
          //link: 'common/client-usage-report',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Organisation Statistics',
          link: window.location.origin + '/common/#/common/organisation-statistics',
          //link: 'common/client-usage-report',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'E-Signature',
          link: window.location.origin + '/common/#/common/e-signature',
          icon: 'fa fa-vine',
          isrighttodisplay: true,
          class: 'menu-item'
        },
        {
          label: 'Scheduler Logs',
          link: window.location.origin + '/common/#/common/schedulerlog',
          icon: 'fa fa-file-pdf-o',
          isrighttodisplay: true,
          class: 'menu-item'
        }
      ]
    }
    // end of super admin
    // application error logs visible to org 1
    if (this.orgId == '1'  ){
      list.push(
          {
            label: 'Application Error Logs',
            link: window.location.origin + '/common/#/common/application-logs',
            icon: 'fas fa-bug',
            isrighttodisplay: true,
            class: 'menu-item'
          }
        )
    }
       
    list.sort((a, b) => a.label.localeCompare(b.label));
    return list
  }

  isActive(path: string): boolean {
    return this.currentUrl === path
  }


  openBackupModal() {
    this.backupModal = true;

  }
  // openDialog() {
  //   this.backupModal = true; 
  //   // this.usermenuVisible = !this.usermenuVisible
  //   // const ref = this.dialogService.open(FullbackupComponent, {
  //   //   header: 'Full Backup',
  //   //   width: '50%',
  //   //   contentStyle: { overflow: 'auto' },
  //   //   data: { api: 'common/commonmasterbackup/commonmastersDataExcel', filename: 'Common-Masters-Full-Backup', message: this.downloadbackupmessage },
  //   //   position: 'top'
  //   // });
  // }

  downloadBackup() {
    this.utilityservice.downloadExcelData(this.backupApi, "get", "").subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Common-Masters-Full-Backup.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.backupModal = false;
      Swal.fire('Common Master Full Backup downloaded successfully!', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }

}
